/** Workflows: the customer facts a condition can name (M29 PDI-006). */
export const workflowsCustomer = {
  conditionGroups: {
    customer: "Customer (signed-in)",
    customerAttributes: "Customer attributes (signed-in)",
  },
  conditionFields: {
    customer_tier: "Customer tier",
    customer_account_status: "Customer account status",
    customer_verified_by: "Customer data confirmed by",
    customer_context_as_of: "Customer data as of",
  },
  conditionChoices: {
    customer_account_status: {
      active: "Active",
      restricted: "Restricted",
      suspended: "Suspended",
      self_excluded: "Self-excluded",
      closed: "Closed",
      kyc_pending: "Identity check pending",
    },
    customer_verified_by: { operator: "The operator's system", staff: "Our team" },
  },
} as const;
